import { useEffect } from "react";

// Sets document title, canonical and meta description for a public page.
export function usePageMeta(title, path, description) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    const canon = document.head.querySelector('link[rel="canonical"]') || document.head.appendChild(Object.assign(document.createElement("link"), { rel: "canonical" }));
    canon.href = `https://astralogico.com${path}`;
    const desc = document.head.querySelector('meta[name="description"]');
    const prevDesc = desc?.content;
    if (desc && description) desc.content = description;
    window.scrollTo(0, 0);
    return () => { document.title = prev; canon.remove(); if (desc) desc.content = prevDesc; };
  }, [title, path, description]);
}
